module.exports = __webpack_public_path__ + "static/media/commentExclamationBlack.7f464391.svg";